// extracted by mini-css-extract-plugin
module.exports = {"star":"ww0efwDL0u8TADljg+xvnw==","count":"TXlyrKISrSCGr+jLJQV6cw==","rating":"LYO2aTgci2gafL+a09qN3A=="};